import { driver } from "driver.js";
import "driver.js/dist/driver.css";

const COMMON_OPTIONS = {
  showProgress: true,
  animate: true,
  nextBtnText: "Suivant",
  prevBtnText: "Précédent",
  doneBtnText: "Terminer",
  progressText: "{{current}} / {{total}}",
  overlayOpacity: 0.55,
};

export function runTour(key, steps, { force = false } = {}) {
  const seenKey = `hfacs_tour_seen_${key}`;
  if (!force && localStorage.getItem(seenKey)) return;
  const el = (testid) => `[data-testid="${testid}"]`;
  const availableSteps = steps.filter((s) => document.querySelector(el(s.testid)));
  if (availableSteps.length === 0) return;
  localStorage.setItem(seenKey, "1");
  const driverObj = driver({
    ...COMMON_OPTIONS,
    onDestroyed: () => localStorage.setItem(seenKey, "1"),
    steps: availableSteps.map((s) => ({ element: el(s.testid), popover: { title: s.title, description: s.description } })),
  });
  driverObj.drive();
}

export const dashboardTourSteps = [
  { testid: "dashboard-welcome", title: "Bienvenue sur HFACS", description: "Voici votre tableau de bord : vue d'ensemble de toutes les analyses d'incidents de votre périmètre." },
  { testid: "dashboard-new-analysis-button", title: "Nouvelle analyse", description: "Démarrez une nouvelle investigation HFACS à partir d'un incident survenu sur site." },
  { testid: "dashboard-import-analysis-button", title: "Importer une analyse", description: "Vous avez déjà une analyse HFACS existante (Excel/CSV) ? Importez-la ici, l'IA en extrait les faits et facteurs." },
  { testid: "analyses-grid", title: "Vos analyses", description: "Retrouvez ici toutes vos analyses en cours ou terminées, cliquez sur une carte pour l'ouvrir." },
];

export function analysisTourSteps(canUseCopilot) {
  const steps = [
    { testid: "analysis-id-title", title: "Identifiant de l'analyse", description: "Chaque analyse HFACS a un identifiant unique attribué automatiquement." },
    { testid: "analysis-tab-chronology", title: "Chronologie", description: "Consignez les faits de l'incident dans l'ordre chronologique, avant toute interprétation." },
    { testid: "analysis-tab-factors", title: "Facteurs HFACS", description: "Sélectionnez les facteurs humains et organisationnels retenus dans le référentiel HFACS." },
  ];
  if (canUseCopilot) {
    steps.push({ testid: "analysis-tab-copilot", title: "Copilote IA", description: "Réservé à l'administrateur national : l'IA suggère des facteurs potentiellement manquants à partir des faits saisis." });
  }
  steps.push(
    { testid: "analysis-tab-critical-paths", title: "Chemins critiques", description: "Identifiez et validez les enchaînements de facteurs les plus déterminants dans la survenue de l'incident." },
    { testid: "analysis-tab-hfix", title: "Plan HFIX", description: "Définissez les actions correctives et leur score de priorité (faisabilité x efficacité)." },
    { testid: "analysis-open-diagram-button", title: "Analyse causale", description: "Visualisez et reliez les facteurs entre eux dans un diagramme causal interactif." },
    { testid: "analysis-open-meeting-button", title: "Mode Réunion", description: "Projetez l'analyse en plein écran pour l'animer devant un comité ou en réunion de sécurité." },
  );
  return steps;
}
